/**
 * Asks intercom API to show the Messenger.
 * https://developers.intercom.com/installing-intercom/docs/intercom-javascript#section-intercomshow
 * @param {String} [message] when provided opens Intercom Messenger pre-populated
 * with this message.
 */
import ERROR from 'errors/errorids';
import AppError from '../errors/apperror';
import Logger from '../logger/logger';
const log = Logger.get('intercom');

export const openIntercomChat = (message, showMessageTab, errorCallback) => {
	if (!window.Intercom) {

		errorCallback(ERROR.SEGMENT_NOT_LOADED);

		const nError = new AppError({
			message: 'openIntercomChat failed',
			errorId: ERROR.UNKNOWN,
			visualisers: { feature: 'INTERCOM' }
		});
		log.send(nError);

		return;
	}

	if (message || showMessageTab) {
		window.Intercom('showNewMessage', message || '');
	} else {
		window.Intercom('show');
	}
};


// WEBPACK FOOTER //
// ./src/utils/intercom.js